import React from "react";

const Discover = () => (
  <svg
    width="35"
    height="25"
    viewBox="0 0 35 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="35" height="25" fill="#FFA201" rx="4"></rect>
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M14.55 10.1h.15c.35 0 .75.05 1.05.25v1a1.4 1.4 0 0 0-1.05-.5 1.5 1.5 0 0 0-1.4 1.55v.1c0 .8.65 1.4 1.45 1.4.4 0 .75-.2 1-.5v1c-.35.15-.7.25-1.1.25a2.28 2.28 0 0 1-2.25-2.3c0-1.3 1-2.35 2.3-2.25zm6.85 0l1.15 3 1.2-3h.9l-1.85 4.55h-.45L20.5 10.1h.9zM10.57 10h.13c.45 0 .9.2 1.25.5l-.45.6c-.2-.2-.45-.35-.7-.35-.3-.05-.55.2-.6.5 0 .25.15.35.65.55 1 .4 1.25.7 1.3 1.3v.15c-.05.8-.7 1.4-1.5 1.35-.6 0-1.2-.3-1.5-.85l.55-.55c.15.35.5.6.9.6h.05c.3 0 .6-.3.6-.65 0-.2-.1-.35-.25-.45-.2-.1-.4-.2-.6-.25-.8-.25-1.05-.6-1.05-1.2v-.05c.05-.7.65-1.25 1.35-1.2zm-5.07.1a2.18 2.18 0 0 1 2.1 2.25c0 .65-.3 1.25-.8 1.7-.45.35-1 .55-1.55.5H4V10.1zm3.3 0v4.45h-.85V10.1h.85zm18.65 0v.75H25.9v1h1.5v.75h-1.5v1.2h1.55v.75h-2.4V10.1h2.4zm1.8 0c1 0 1.55.45 1.55 1.3.05.65-.4 1.2-1 1.3l1.35 1.85H30.1l-1.15-1.8h-.1v1.8H28V10.1zm-24 .74l-.15.01h-.25v2.95h.25c.4.05.85-.1 1.15-.35.3-.3.45-.7.45-1.15 0-.4-.15-.8-.45-1.1-.3-.25-.75-.4-1.15-.35zm23.85-.04h-.25v1.35h.25c.55 0 .8-.25.8-.7 0-.4-.25-.65-.8-.65z"
      ></path>
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M18.35 10.05c-1.25 0-2.3 1-2.3 2.3 0 1.25 1 2.3 2.3 2.35 1.3.05 2.3-1 2.35-2.3a2.38 2.38 0 0 0-2.35-2.35z"
        opacity=".8"
      ></path>
    </g>
  </svg>
);

export default Discover;
